import { Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StyledTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    border: "1px solid #DADDE9",
    borderRadius: "4px",
    fontSize: 16,
    fontWeight: 400,
    padding: "0.7rem",
    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
  },
}))(Tooltip);

export default StyledTooltip;
